/* Store-wide pointer light and gentle section entrances. */
(() => {
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const editor = Boolean(window.Shopify?.designMode);
  let cursor, aura, raf = 0, smooth, scrollRaf = 0;
  let x = -200, y = -200, ax = -200, ay = -200, targetX = -200, targetY = -200;

  function frame() {
    x += (targetX - x) * .27;
    y += (targetY - y) * .27;
    ax += (targetX - ax) * .075;
    ay += (targetY - ay) * .075;
    cursor.style.transform = `translate3d(${x}px,${y}px,0) translate(-50%,-50%)`;
    aura.style.transform = `translate3d(${ax}px,${ay}px,0) translate(-50%,-50%)`;
    raf = requestAnimationFrame(frame);
  }
  function pointer(event) {
    targetX = event.clientX;
    targetY = event.clientY;
    const target = event.target;
    const viewer = target.closest?.('.uae3d__stage, [data-uae-hero] #view, .story-world, [data-uae-tile-stage]');
    const action = target.closest?.('a,button,[role="button"],[role="tab"],summary,.product-card,.find-slot');
    const input = target.closest?.('input,textarea,select,[contenteditable="true"]');
    const visible = !input && fine.matches && !reduce.matches && !editor;
    cursor.classList.toggle('is-active', visible);
    aura.classList.toggle('is-active', visible);
    cursor.classList.toggle('is-interactive', Boolean(action) && visible);
    cursor.classList.toggle('is-viewer', Boolean(viewer) && visible);
    cursor.dataset.label = viewer ? (viewer.matches('.uae3d__stage, #view, .story-world') ? 'DRAG' : 'VIEW') : '';
    if (viewer?.matches('.uae3d__stage')) {
      const rect = viewer.getBoundingClientRect();
      viewer.style.setProperty('--uae-pointer-x', `${(event.clientX - rect.left) / rect.width * 100}%`);
      viewer.style.setProperty('--uae-pointer-y', `${(event.clientY - rect.top) / rect.height * 100}%`);
    }
    const local = action?.getBoundingClientRect();
    if (local && local.width < 600) {
      action.style.setProperty('--uae-light-x', `${(event.clientX - local.left) / local.width * 100}%`);
      action.style.setProperty('--uae-light-y', `${(event.clientY - local.top) / local.height * 100}%`);
    }
  }
  function init() {
    if (!document.body.classList.contains('uae-home') && !editor && !reduce.matches && window.Lenis) {
      smooth = new window.Lenis({
        lerp: .105, smoothWheel: true, syncTouch: false, anchors: true,
        prevent: node => Boolean(node.closest?.('.uae3d__stage, [data-lenis-prevent], dialog, [role="dialog"]'))
      });
      const scrollFrame = time => { smooth?.raf(time); scrollRaf = requestAnimationFrame(scrollFrame); };
      scrollRaf = requestAnimationFrame(scrollFrame);
    }
    if (fine.matches && !reduce.matches && !editor) {
      cursor = document.createElement('span');
      cursor.className = 'uae-cursor-halo';
      cursor.setAttribute('aria-hidden', 'true');
      cursor.innerHTML = '<span class="uae-cursor-core"></span>';
      aura = document.createElement('span');
      aura.className = 'uae-cursor-aura';
      aura.setAttribute('aria-hidden', 'true');
      document.body.append(aura, cursor);
      document.addEventListener('pointermove', pointer, { passive: true });
      document.addEventListener('pointerout', event => {
        if (!event.relatedTarget) { cursor.classList.remove('is-active'); aura.classList.remove('is-active'); }
      });
      raf = requestAnimationFrame(frame);
    }
    if (reduce.matches || editor || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    }, { rootMargin: '0px 0px -4% 0px', threshold: .04 });
    const reveal = scope => {
      scope.querySelectorAll('.featured-heading, .featured-grid .product-card, .store-benefits .benefit, .store-faq > div, .store-faq .faq-list').forEach((element, i) => {
        if (element.classList.contains('uae-motion-ready')) return;
        element.classList.add('uae-motion-ready');
        element.style.setProperty('--uae-reveal-delay', `${Math.min(i % 5, 4) * 65}ms`);
        observer.observe(element);
      });
    };
    reveal(document);
    document.addEventListener('shopify:section:load', event => reveal(event.target));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  window.addEventListener('pagehide', () => {
    if (raf) cancelAnimationFrame(raf);
    if (scrollRaf) cancelAnimationFrame(scrollRaf);
    smooth?.destroy();
  });
})();
